import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, DocumentReference } from '@angular/fire/firestore';
import { Product } from './Product';
import { AngularFireStorage } from '@angular/fire/storage';

@Injectable({
    providedIn: "root"
})
export class ProductService {
    
    public async updateProduct(product: Product, id: any) {
        return await this.getCollection().doc(id).update(product)
      }
     public deleteProduct(productId: string) {
        if (productId) {
          try{
            this.deleteProductImage(productId)
          }
          catch{
            console.log(`Failed to delete product with Id ${productId}`)
          }
          return this.getCollection().doc(productId).delete().then(() => { return true });
        }
        return false;
      }
    
      constructor(public firestore: AngularFirestore, private storage: AngularFireStorage) {
      }
    
      public getCollection(): AngularFirestoreCollection {
        const collection = this.firestore.collection(`products`);
        return collection;
      }

      private deleteProductImage(imageName : string){
        this.storage.ref(`products/${imageName}`).delete();
      }

      private getProductImageUrl(docId) {
      const ref = this.storage.ref(`products/${docId}`);
      return ref.getDownloadURL().toPromise()
      }
    
      public getPropertyTypes(){
        return this.firestore.collection(`propertyTypes`).get().toPromise()
      }
    
      public addProduct(product: Product): Promise<DocumentReference> {
        return this.getCollection().add(product);
      }
    
}